<template>
  <article class="gs-gateway-card">
    <div class="gs-gateway-card__logo">
      <stripe-logo-icon v-if="gatewayIntegration.platform == 'stripe'" class="gs-gateway-card__logo-icon" />
      <paypal-logo-icon
        v-else-if="gatewayIntegration.platform == 'paypal' || gatewayIntegration.platform == 'paypal_commerce'"
        class="gs-gateway-card__logo-icon" />
      <div
        v-else-if="['commas', 'increase_billing'].includes(gatewayIntegration.platform)"
        class="gs-gateway-card__logo-text"
      >
        {{ gatewayIntegration.platform === 'increase_billing' ? 'Increase' : 'ScaleGG Pay' }}
      </div>
      <div v-else class="gs-gateway-card__logo-image" :style="{
        backgroundImage:
          'url(' +
          require('@/assets/images/logo/' +
            gatewayIntegration.platform +
            '-integration.png') +
          ')',
      }"></div>
    </div>
    <div class="gs-gateway-card__footer">
      <p class="gs-gateway-card__name">{{ gatewayName }}</p>
      <drop-menu :menu-items="menuItems" small></drop-menu>
    </div>
  </article>
</template>
<style>
.gs-gateway-card {
  display: flex;
  min-width: 0;
  flex-direction: column;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
  transition: border-color 150ms ease, box-shadow 150ms ease;
}

.gs-gateway-card:hover {
  border-color: var(--gs-border-strong);
  box-shadow: var(--gs-shadow-md);
}

.gs-gateway-card__logo {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  padding: 20px;
  background: var(--gs-surface-subtle);
  border-bottom: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg) var(--gs-radius-lg) 0 0;
}

.gs-gateway-card__logo-icon {
  width: 100%;
  height: 56px;
  object-fit: contain;
}

.gs-gateway-card__logo-text {
  color: var(--gs-foreground);
  font-size: 20px;
  font-weight: 700;
  text-align: center;
}

.gs-gateway-card__logo-image {
  width: 100%;
  height: 56px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.gs-gateway-card__footer {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 10px 10px 16px;
}

.gs-gateway-card__name {
  min-width: 0;
  flex: 1 1 auto;
  margin: 0;
  color: var(--gs-foreground);
  font-size: 14px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

/* Restyle the third-party drop-menu trigger as a ghost icon button (CSS only). */
.gs-gateway-card__footer .select-none {
  width: 36px;
  height: 36px;
}

.gs-gateway-card__footer .select-none > div:first-child {
  width: 36px;
  height: 36px;
  border-radius: var(--gs-radius-md);
  color: var(--gs-muted-foreground);
  transition: background-color 150ms ease, color 150ms ease;
}

.gs-gateway-card__footer .select-none > div:first-child:hover {
  color: var(--gs-foreground);
  background: var(--gs-muted);
}

.gs-gateway-card__footer .select-none > div:first-child svg {
  width: 18px;
  height: 18px;
}

.gs-gateway-card__footer .select-none .absolute {
  margin-top: 42px;
}

.gs-gateway-card__footer .select-none .absolute > div {
  border-color: var(--gs-border);
  border-radius: var(--gs-radius-md);
  box-shadow: var(--gs-shadow-md);
}
</style>
<script>
import StripeLogoIcon from '@/assets/images/logo/StripeLogoIcon.svg';
import PaypalLogoIcon from '@/assets/images/logo/PaypalLogoIcon.svg';

export default {
  name: 'FunnelGridAsset',
  components: {
    StripeLogoIcon,
    PaypalLogoIcon,
  },
  props: {
    gatewayIntegration: {},
  },
  computed: {
    gatewayName() {
      return this.gatewayIntegration.platform === 'commas'
        ? 'ScaleGG Pay'
        : this.gatewayIntegration.name;
    },

    menuItems() {
      const menuItems = [];

      menuItems.push(
        {
          text: this.$t('frontend_groovesell_reporting_overide'),
          callback: () =>
            this.$emit('onProcessingFeeClick', this.gatewayIntegration.id),
        },
        {
          text: this.$t('frontend_groovesell_edit'),
          callback: () =>
            this.$emit('onEditGatewayIntegration', this.gatewayIntegration.id),

        },
        {
          text: this.$t('frontend_groovesell_delete'),
          callback: () =>
            this.$emit('onDeleteGatewayIntegration', this.gatewayIntegration.id),
        }
      );

      return menuItems;
    },
  },
};
</script>
